import { DynamicSubtitleProps } from 'sly/hubPage/components/HubDynamicContent/DynamicSubtitle/DynamicSubtitle.types';
import Heading from 'sly/system/Heading';

export default function DynamicSubtitle({
  value,
  hrefId,
}: DynamicSubtitleProps) {
  if (!value) return null;
  return (
    <Heading
      font='font-t-l'
      className='font-t-l mb-l w-[calc(100%-2rem)] md:mb-xl md:w-[var(--col6)] lg:w-[var(--col8)]'
      id={hrefId}
      data-tp-id='gen-Heading-5c24c427-996b-4bfa-8a7a-f7815dba293c'
    >
      {value}
    </Heading>
  );
}
